<router-outlet></router-outlet>

<div class="mt-3">
  <cap-rubrik [isClosable]="true" [isOpen]="true" id="links-im-menu-unterstuetzung">
    <ng-container class="mt-2" title>
      <h3 class="mb-0">{{ titleKey | translate }}</h3>
    </ng-container>
    <div class="btn-group btn-group-sm float-end" data-toggle="buttons" titleActionButtons>
      @if (isReadOnlyMode()) {
        <button (click)="onEdit()" class="btn btn-outline-primary btn-sm" type="button">
          <i class="fas fa-pen me-2"></i>{{ "functionbar.edit" | translate }}
        </button>
      }
      @if (isEditMode()) {
        <button (click)="onNew()" class="btn btn-outline-primary btn-sm text-end me-2" type="submit">
          <i class="fas fa-plus me-2"></i>{{ "functionbar.new" | translate }}
        </button>
        <button (click)="onCancel()" class="btn btn-outline-primary btn-sm me-2" type="button">
          <i class="fas fa-times me-2"></i>{{ "functionbar.cancel" | translate }}
        </button>
        <button (click)="onSave()" class="btn btn-primary btn-sm" type="submit">
          <i class="fas fa-check me-2"></i>{{ "functionbar.save" | translate }}
        </button>
      }
    </div>
    <table class="cap-table-detail mt-2 mb-1">
      <thead>
        <tr>
          <th class="w-25">{{"Name"}}</th>
          <th class="w-50">{{"Url" | translate}}</th>
          <th class="w-auto"></th>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
    <div (cdkDropListDropped)="drop($event)" cdkDropList cdkDropListDisabled="{{ !isEditMode() }}" class="link-box">
      @for (link of linkEntries; track link) {
        <div cdkDrag cdkDragBoundary=".link-box" class="input-group mt-0">
          <ng-container>
            <div class="w-25">
              <label
                [attr.for]="'linkText' + link.name"
                [ngStyle]="{ cursor: isEditMode() ? 'pointer' : 'default' }"
                class="form-control link-label h-100">
                @if (isEditMode()) {
                  <i aria-hidden="true" class="fas fa-arrows-alt fa-fw text-primary" style="opacity: 0.7"></i>
                }
                {{ link | translateLinkName: "TEXT" }}
              </label>
            </div>
            <ng-template [ngTemplateOutlet]="linkGroupCol" [ngTemplateOutletContext]="{ $implicit: link }"></ng-template>
            @if (isEditMode()) {
              <div>
                <ng-template [ngTemplateOutlet]="buttonGroupCol" [ngTemplateOutletContext]="{ $implicit: link }"></ng-template>
              </div>
            }
          </ng-container>
        </div>
      }
    </div>
  </cap-rubrik>
</div>

<ng-template #linkGroupCol let-link>
  <div [ngStyle]="{ cursor: isEditMode() ? 'pointer' : 'default' }" class="w-50 form-control linkLabel h-auto">
    {{ link | translateLinkName: "LINK" }}
  </div>
</ng-template>

<ng-template #buttonGroupCol let-link>
  <div class="w-auto">
    <div class="input-group-text buttonCol">
      <button (click)="onEditLink(link.id)" [disabled]="isReadOnlyMode()" class="btn btn-outline-primary btn-sm me-2" type="button">
        <i class="fas fa-pen"></i>
      </button>
      <button
        (click)="onDelete(link)"
        [disabled]="isReadOnlyMode()"
        [ngbTooltip]="'functionbar.delete' | translate"
        class="btn btn-danger btn-sm"
        placement="bottom"
        type="button">
        <i class="fas fa-trash"></i>
      </button>
    </div>
  </div>
</ng-template>
